import { Toolbar, SaveButton, DeleteWithUndoButton } from "react-admin";
import { withStyles } from "@mui/styles";
import React from "react";
import BackButton from "../buttons/backButton.component";

const toolbarStyles = {
  toolbar: {
    display: "flex",
    justifyContent: "space-between",
  },
};

export const CustomToolbar = withStyles(toolbarStyles)((props: any) => (
  <Toolbar>
    {(props as any).noRedirect ? (
      <SaveButton mutationOptions={{
        onSuccess: () => {}
      }}/>
    ) : (
      <SaveButton />
    )}

    {/*<BackButton>Back</BackButton>*/}
    {!(props as any).noDelete && <DeleteWithUndoButton />}
  </Toolbar>
));

export default CustomToolbar;
